import { atom } from "jotai";

export type QueryFormatSelectRaw = {
    query: string
    fields?: { field: string; type?: string }[]
}

export const integrationListAtom = atom<[]>([])
export const actionRawSQLAtom = atom<{ open: boolean, value?: QueryFormatSelectRaw, onRun?: boolean }>({ open: false })